import Layout from '@/layout/index.vue';
var agencyRouter = {
  path: '/agency',
  name: 'Agency',
  component: Layout,
  meta: {
    title: '代理管理'
  },
  children: [{
    path: 'level',
    component: function component() {
      return import('@/views/agency/level/index');
    },
    name: 'AgencyLevel',
    meta: {
      title: '代理等级',
      icon: ''
    }
  }, {
    path: 'relationship',
    component: function component() {
      return import('@/views/agency/relationship/index');
    },
    name: 'AgencyRelationship',
    meta: {
      title: '邀请关系',
      icon: ''
    }
  }, {
    path: 'daily',
    name: "AgencyDaily",
    meta: {
      title: '代理用户日报'
    },
    component: function component() {
      return import('@/views/agency/daily/index');
    }
  }, {
    path: 'summary',
    name: "AgencySummary",
    meta: {
      title: '代理用户汇总'
    },
    component: function component() {
      return import('@/views/agency/summary/index');
    }
  }, {
    path: 'invite',
    name: 'AgencyInvite',
    component: function component() {
      return import('@/views/agency/inviteSettled');
    },
    meta: {
      title: '代理邀请佣金'
    }
  }, {
    path: 'commission',
    component: function component() {
      return import('@/views/agency/commissionSettled');
    },
    name: 'AgencyCommission',
    meta: {
      title: '代理佣金'
    }
  }]
};
export default agencyRouter;